export default "__VITE_ASSET__gC$JLy6F__"